import { graphql } from '@apollo/client/react/hoc';
import * as React from 'react';

import { map } from 'lodash';
import BatchRoleCorrectionModalCommon from './BatchRoleCorrectionModalCommon';

import GET_ORG_USER_AFFILIATIONS_QUERY from './queries/GetOrgAffiliationViewsQuery.gql';

import type { GetOrganizationMembers_organizations_members_members_user } from 'components/PeopleList/TableDataContainer/__generated__/GetOrganizationMembers';

import type { ComponentType } from 'react';

// Stuff that needs to be passed in
type NonLoaderProps = {
  users: GetOrganizationMembers_organizations_members_members_user[];
  onUserRoleSave: () => void;
  organization: {
    readonly id: Backbone$Id;
    readonly uuid: string;
  };
};

type Props = NonLoaderProps & {
  // comes from the query
  orgAffiliationViewsByUserId: any;
  loading: boolean;
};

function BatchRoleCorrectionModalForPeopleListDataContainer(props: Props) {
  const { users, orgAffiliationViewsByUserId, organization, loading, onUserRoleSave, ...others } =
    props;

  const userData = loading
    ? []
    : map(users, (u) => ({
        user: u,
        orgAffiliationView: orgAffiliationViewsByUserId[u.id],
      }));

  return (
    // $FlowFixMe
    <BatchRoleCorrectionModalCommon
      {...others}
      loading={loading}
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Backbone$Id' is not assignable t... Remove this comment to see the full error message
      organizationId={parseInt(organization.id, 10)}
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      userData={userData}
      onUserRoleSave={onUserRoleSave}
    />
  );
}

const withOrgAffiliationViews = graphql(GET_ORG_USER_AFFILIATIONS_QUERY, {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'organization' does not exist on type '{}... Remove this comment to see the full error message
  options: ({ organization, users }) => {
    return {
      variables: {
        orgUuid: organization.uuid,
        userUuids: map(users, (u) => u.uuid),
      },
    };
  },
  props: ({ data }) => {
    const orgAffiliationViewsByUserId = {};
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    if (data.organizations && data.organizations.length > 0) {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      data.organizations[0].userAffiliations.forEach((oua) => {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        orgAffiliationViewsByUserId[oua.user_id] = oua;
      });
    }
    return {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      loading: data.loading,
      orgAffiliationViewsByUserId,
    };
  },
});

// @ts-expect-error ts-migrate(2352) FIXME: Conversion of type 'ComponentClass<{}, any>' to ty... Remove this comment to see the full error message
export default withOrgAffiliationViews(
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '(props: Props) => Element' is no... Remove this comment to see the full error message
  BatchRoleCorrectionModalForPeopleListDataContainer
) as ComponentType<NonLoaderProps>;
